import {addAuthToAxiosOpts} from '../config/queryopts'
import {useQueryWithAuthentication} from "./index";
import {apiUrlInternal} from "../config/api"
import axios from "axios";
import _ from "lodash";


export const ProjectsOrganizationKeywordFetcher = (uid, accessToken) => {
  return axios.get(
    `${apiUrlInternal}/keyword_projects/organizations/${uid}`,
    addAuthToAxiosOpts(accessToken, {})
  ).then(res => res.data);
}


export const useProjectsOrganizationKeywordQuery = (uid, fetcher = ProjectsOrganizationKeywordFetcher) => {
  return useQueryWithAuthentication(
    ['organizations-keyword-projects', uid],
    (accessToken) => fetcher(uid, accessToken),
    {refetchOnWindowFocus: false, enabled: !_.isNull(uid) && !_.isUndefined(uid)}
  )
}
